/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Kpi_Contract_SeatsInputs */



/**
* | output |
* | --- |
* | "Contracted seats" |
*
* @param {Partner_Org_Kpi_Contract_SeatsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_kpi_contract_seats = /** @type {((inputs?: Partner_Org_Kpi_Contract_SeatsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Kpi_Contract_SeatsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vereinbarte Plätze")
	return /** @type {LocalizedString} */ ("Contracted seats")
});